import { Component, OnInit } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { ProductService } from '../../../services/product.service';
import { filter, takeUntil } from 'rxjs/operators';
import { FavouritesService } from '../../../services/favourites.service';
import { Store } from '../../../store';
import { BreadcrumbsService } from '../../../services/breadcrumbs.service';
import { SeoService } from 'src/app/services/seo.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
    selector: 'app-product-range-detail',
    templateUrl: './product-range-detail.component.html',
    styleUrls: ['./product-range-detail.component.scss'],
})
export class ProductRangeDetailComponent implements OnInit {
    productRange;
    products = [];
    favourites$ = this.store.select<any[]>('favourites');
    isLoaded = false;
    public destroyed = new Subject<any>();
    rewardDiscount;
    user = this.store.selectForLocal('user');
    private contentLoaded$ = new BehaviorSubject<boolean>(false);

    constructor(
        private store: Store,
        private route: ActivatedRoute,
        private router: Router,
        private productsService: ProductService,
        private favouritesService: FavouritesService,
        private breadcrumbsService: BreadcrumbsService,
        private seoService: SeoService,
        private overlayService: OverlayService
    ) {}

    ngOnInit(): void {
        this.getProductRanges();

        this.router.events
            .pipe(
                filter((event: RouterEvent) => event instanceof NavigationEnd),
                takeUntil(this.destroyed)
            )
            .subscribe(() => {
                this.getProductRanges();
            });

        this.overlayService.addLoadingSubject(this.contentLoaded$);
    }

    ngOnDestroy(): void {
        this.destroyed.next();
        this.destroyed.complete();
    }

    getProductRanges() {
        this.productsService.getProductRange(this.route.snapshot.params.slug).subscribe(
            (data) => {
                this.productRange = data.data;
                this.isLoaded = true;
                this.breadcrumbsService.changeBreadcrumb([
                    { text: 'Our Ranges', route: ['/product-ranges'] },
                    { text: this.productRange.name },
                ]);
                this.productsByRange(this.productRange);
                this.setMetaTags(data.data);
            },
            (error) => {
                this.isLoaded = true;
                this.contentLoaded$.next(true);
            }
        );
    }

    productsByRange(productRange) {
        this.productsService.productsByRange(productRange).subscribe((data) => {
            this.products = data.data;
            if (this.user) {
                this.rewardDiscount = this.user.rewardDiscount;
            } else {
                this.rewardDiscount = 0;
            }
            this.contentLoaded$.next(true);
        });
    }

    toggleFavourite(productId) {
        const favourites = this.store.selectForLocal('favourites');
        if (favourites.indexOf(productId) < 0) {
            this.favouritesService.addToFavourites(productId);
        } else {
            this.favouritesService.deleteFavourite(productId);
        }
    }

    setMetaTags(productRange) {
        this.seoService.updateTitle(productRange.seoTitle);
        this.seoService.addMetaTag('description', productRange.seoDescription);
        this.seoService.createLinkForCanonicalURL();
    }
}
